import { FileTypes } from '@dynamik/common/clients/inboxv2-clients';

export class FileTypesValueConverter {
  toView(ft: FileTypes): string {
    switch (ft) {
      case FileTypes.MultiLineImportFile: return 'Excel/Csv';
      case FileTypes.Voucher: return 'Pdf';
      case FileTypes.Report: return 'Report';

      default: return '';
    }
  }
}
